import { render, staticRenderFns } from "./overlay-topic-item-detail.vue?vue&type=template&id=25ea2ca9"
import script from "./overlay-topic-item-detail.vue?vue&type=script&lang=js"
export * from "./overlay-topic-item-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports